<template>
  <span>
    <v-row dense justify="center">
      <v-col cols="12" md="auto" class="flex-md-grow-1">
        <v-card class="my-1 elevation-0" style="height: 98.5%;">
          <v-card-text>
            <kpis-by-municipio-data-table
              :dadosKpisByMunicipio="dadosPorMunicipio"
              :traducaoIndicadores="traducaoIndicadores"
              :loading="loadingPorChave.dadosPorMunicipio"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="auto" class="flex-md-grow-1">
        <v-card class="my-1 elevation-0">
          <v-card-text>
            <kpis-by-municipio-map
              :dadosKpisByMunicipio="dadosPorMunicipio"
              :loading="loadingPorChave.dadosPorMunicipio"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row dense justify="center">
      <v-col cols="12">
        <v-card-charts-dashboard
          v-for="chart in chartDataComputed"
          :key="chart.title"
          :title="chart.title"
          :options="chart.options"
          :deep-copy-on-update="false"
          :is-loading="chart.loading"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
HighchartsNoData(Highcharts);
import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import { mapState } from "vuex";
import DashboardCobrancasIrregularidadesService from "@/services/DashboardCobrancasIrregularidades";

exporting(Highcharts);
exportData(Highcharts);

export default {
  name: "DashboardCobrancasIrregularidadesVisaoMunicipios",
  components: {
    KpisByMunicipioDataTable: () =>
      import(
        "@/components/dashboardCobrancasIrregularidades/KpisByMunicipioDataTable.vue"
      ),
    KpisByMunicipioMap: () =>
      import(
        "@/components/dashboardCobrancasIrregularidades/KpisByMunicipioMap.vue"
      ),
    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    activatedTab: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dadosPorMunicipio: {},
      traducaoIndicadores: {
        qtd_inspecoes:
          "Quantidade de Inspeções (Verificação de Procedimentos Irregulares)",
        qtd_tois: "Quantidade de TOIs Emitidas",
        qtd_tois_cobradas: "Quantidade de TOIs Cobradas",
        percentual_tois: "Percentual de TOIs com Cobrança (%)",
      },
      loadingPorChave: {
        dadosPorMunicipio: false,
      },
      chartData: [
        {
          title: "Percentual de TOIs com Cobrança (%)",
          chartOptionsKey: "chartPercentualToisOptions",
        },
        {
          title:
            "Quantidade de Inspeções (Verificação de Procedimentos Irregulares)",
          chartOptionsKey: "chartQuantidadeInspecoesOptions",
        },
        {
          title:
            "Quantidade de TOIs com Cobrança por Procedimento Irregular Comprovado",
          chartOptionsKey: "chartQuantidadeToisCobradasOptions",
        },
        {
          title: "Quantidade de TOIs com Cobrança por Deficiência na Medição",
          chartOptionsKey: "chartQuantidadeToisOptions",
        },
      ],
    };
  },
  computed: {
    ...mapState("parametrosDashboardCobrancasIrregularidades", [
      "competencia",
      "competenciaAte",
      "competenciaDe",
      "regionalSelecionada",
      "visaoGraficos",
      "quantidadeMunicipios",
    ]),
    chartDataComputed() {
      const isLoading = !!this.loadingPorChave.dadosPorMunicipio;
      return this.chartData.map((chart) => ({
        ...chart,
        loading: isLoading,
        options: this[chart.chartOptionsKey],
      }));
    },
    chartPercentualToisOptions() {
      return this.criarGrafico({
        dados: this.dadosPorMunicipio,
        campo: "percentual_tois",
        nomeSerie: "Percentual de TOIs (%)",
        tituloY: "Percentual (%)",
        formato: "{y}%",
      });
    },
    chartQuantidadeInspecoesOptions() {
      return this.criarGrafico({
        dados: this.dadosPorMunicipio,
        campo: "qtd_inspecoes",
        nomeSerie: "Quantidade de Inspeções",
        tituloY: "Quantidade",
        formato: "{y}",
      });
    },
    chartQuantidadeToisCobradasOptions() {
      return this.criarGrafico({
        dados: this.dadosPorMunicipio,
        campo: "qtd_tois_cobradas",
        nomeSerie: "Quantidade de TOIs Cobradas",
        tituloY: "Quantidade",
        formato: "{y}",
      });
    },
    chartQuantidadeToisOptions() {
      return this.criarGrafico({
        dados: this.dadosPorMunicipio,
        campo: "qtd_tois",
        nomeSerie: "Quantidade de TOIs",
        tituloY: "Quantidade",
        formato: "{y}",
      });
    },
  },
  watch: {
    competencia() {
      this.getDados();
    },
    competenciaAte() {
      this.getDados();
    },
    competenciaDe() {
      this.getDados();
    },
    regionalSelecionada() {
      this.getDados();
    },
    activatedTab(newVal) {
      if (newVal === 1) {
        this.getDados();
      }
    },
  },
  mounted() {
    this.getDados();
  },
  methods: {
    getDados() {
      if (this.activatedTab !== 1) return;

      this.$emit("updateLoadingDados", true);

      this.getDadosPorMunicipio()
        .catch((err) => {
          console.error(err);
          this.$toast.error("Erro ao recuperar dados", "", {
            position: "topRight",
          });
        })
        .finally(() => this.$emit("updateLoadingDados", false));
    },
    getDadosPorMunicipio() {
      this.loadingPorChave.dadosPorMunicipio = true;
      return DashboardCobrancasIrregularidadesService.getDadosTOIsCobrancasPorInspecoesRealizadasPorMunicipio(
        this.competenciaDe,
        this.competenciaAte,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosPorMunicipio = res;
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loadingPorChave.dadosPorMunicipio = false;
        });
    },
    criarGrafico({ dados, campo, nomeSerie, tituloY, formato, cor }) {
      const dadosOrdenados = Object.entries(dados)
        .map(([municipio, obj]) => ({
          municipio,
          valor: obj?.[campo] || 0,
        }))
        .sort((a, b) => b.valor - a.valor)
        .slice(0, this.quantidadeMunicipios || Infinity);

      const municipios = dadosOrdenados.map((d) => d.municipio);
      const valores = dadosOrdenados.map((d) => d.valor);

      return {
        chart: {
          type: "column",
          zooming: { type: "x" },
          animation: {
            duration: 800,
          },
        },
        title: { text: null },
        xAxis: {
          categories: municipios,
          title: { text: "Municípios" },
        },
        yAxis: {
          title: { text: tituloY },
        },
        tooltip: {
          formatter: function() {
            return `<b>${this.x}</b><br/>${nomeSerie}: ${formato.replace(
              "{y}",
              this.y,
            )}`;
          },
        },
        series: [
          {
            name: nomeSerie,
            data: valores,
            color: cor,
          },
        ],
        credits: { enabled: false },
        exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              menuItems: [
                "viewFullscreen",
                "separator",
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
                "separator",
                "downloadCSV",
                "downloadXLS",
              ],
            },
          },
        },
      };
    },
  },
};
</script>

<style></style>
